import type { FormConfig } from '#types/config/components/vf/form'

export default {
  brandClasses: {
    borderColor: 'b-grey-40',
    text: '[&>input]:text-base'
  }
} satisfies FormConfig['input']
